import { Component } from '@angular/core';
import { TCO } from '../../../../constants';
import { ProductQueueSearchCriteria } from '../../../../models/reservation-v2/criteria/product-queue-search-criteria';
import { MainType } from '../../../../models/reservation-v2/main-type';
import { ProductLevel } from '../../../../models/reservation-v2/product-level';
import { DataKey } from '../../../../services/util/framework/data-store.service';

@Component({
    selector: 'tc-product-queue-search-criteria-gen',
    templateUrl: './product-queue-search-criteria-gen.component.html'
})
export class ProductQueueSearchCriteriaGenComponent {

    inputSearchCriteria = new ProductQueueSearchCriteria();
    searchCriteriaUpdatingDataKey = DataKey.productQueueSearchCriteria;
    searchResultsDataKey = DataKey.productQueueSearchResultsFromService;
    searchCriteriaLoadingDataKey = TCO.AppData.PRODUCT_QUEUE_SEARCH_CRITERIA_GEN;
    chipConfigKey = TCO.CONF.CONF_PRODUCT_QUEUE_SEARCH_CRITERIA_CHIP_GEN;
    paginationConfigKey = 'PRODUCT_QUEUE_SEARCH';
    placeHolderText = 'Search Generic Products';

    createNewSearchCriteriaFn = () => {
        const criteria = new ProductQueueSearchCriteria();
        criteria.productLevel = ProductLevel.ANY;
        criteria.mainType = MainType.GEN;
        criteria.subType = 'ANY';
        return criteria;
    };

    clearLoadedSearchCriteriaFn = (searchCriteria: ProductQueueSearchCriteria) => {
        searchCriteria.productLevel = ProductLevel.ANY;
        searchCriteria.mainType = MainType.GEN;
        searchCriteria.subType = 'ANY';
    };
}
